(() => {
  if (window.obdReviewLinksReady) return;
  window.obdReviewLinksReady = true;
  const config = document.querySelector('[data-obd-review-links-url]');
  if (!config) return;
  const url = config.dataset.obdReviewLinksUrl;
  const selector = '.jdgm-review-widget, .jdgm-carousel, .jdgm-all-reviews-rating, .jdgm-all-reviews-text';
  const attach = () => {
    document.querySelectorAll(selector).forEach(widget => {
      if (widget.dataset.obdAllReviewsLink || widget.closest('product-card, .product-card, .obd-caddy-card, obd-review-wall')) return;
      if (widget.parentElement?.closest(selector)) return;
      if (widget.getBoundingClientRect().height === 0) return;
      widget.dataset.obdAllReviewsLink = 'true';
      const link = document.createElement('a');
      link.className = 'obd-all-reviews-link obd-app-review-link';
      link.href = url; link.textContent = 'See All Reviews';
      widget.after(link);
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; attach(); });
  });
  attach();
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('jdgm.doneSetup', attach);
  document.addEventListener('shopify:section:load', attach);
})();
